import React, {useState} from 'react';
import Breadcrumb from '../../../common/breadcrumb';
import ShopTimeEntryReviewBody from "./shopTimeEntryReviewBody";
import LoadingIndicator from "../../../common/loadingIndicator";
import PayPeriodFormFilter from "../../../common/form-filters/PayPeriodFormFilter";

/**
 * ShopTimeEntryReview Component
 * @returns {JSX.Element}
 * @constructor
 */
const ShopTimeEntryReview = () => {
    const [tableData, setTableData] = useState([]);
    const [filters, setFilters] = useState({
        pay_period_id: '',
        isLoading: false,
        isSubmitted: false,
    });

    return (
        <>
            <Breadcrumb title="Shop Time Entry Review" parent="Time Entry"/>
            <PayPeriodFormFilter {...{setFilters, setTableData, OnSubmitUrl:"getShopTimeEntriesByPayPeriodId"}}/>
            <ShopTimeEntryReviewBody {...{filters, setFilters, tableData, setTableData}}/>
            <LoadingIndicator isLoading={filters.isLoading}/>
        </>
    );
}

export default ShopTimeEntryReview;
